import { Transition, TransitionEvents } from '@headlessui/react';
import React from 'react';

// Hard to type this until @headlessui/react gets their types reasonably consumable...
type Props = TransitionEvents &
  React.HTMLAttributes<any> & {
    as?: any;
    show: boolean;
  };

const SlideInFromRight: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => (
  <Transition
    as="div"
    {...props}
    enter="transition-all ease-in-out duration-300"
    enterFrom="opacity-0 translate-x-4"
    enterTo="opacity-100 translate-x-0"
    leave="transition-all ease-in-out duration-300"
    leaveFrom="opacity-100 translate-x-0"
    leaveTo="opacity-0 translate-x-4"
  >
    {children}
  </Transition>
);

export default SlideInFromRight;
